__turbopack_context__.v({
  "pageLoadOverlay": "pageloading-module-scss-module__NvR_wq__pageLoadOverlay",
});
